import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../layouts";
import Breadcrumb from "../../components/Breadcrumb";
import { useOrganisationStore } from "../../store";

export default function Declaration({ appType }) {
  const formRef = useRef();
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();
  const store = useOrganisationStore();

  const onNext = () => {
    setShowAlert(!store.form.agree);
    if (!store.form.agree) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }

    if (store.form.agree) {
      navigate(`/organisation/app/${appType}/form`);
    }
  };

  const onCancelApp = () => {
    store.clearForm();
    navigate(`/organisation`);
  };

  return (
    <Layout mType="organisation">
      <div className="container mx-auto" ref={formRef}>
        <div className="lg:py-5 lg:px-0 py-4 px-4">
          <Breadcrumb mType="organisation" appType={appType} />

          {showAlert && (
            <div
              class="flex p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
              role="alert"
            >
              <svg
                aria-hidden="true"
                class="flex-shrink-0 inline w-5 h-5 mr-3"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="sr-only">Info</span>
              <div>
                <span class="font-medium">Error:</span> You must agree to
                "Personal Information Collection Statement" and "Terms and
                Conditions of Application for EdUHK Library Membership".
              </div>
            </div>
          )}

          <h1 className="font-bold text-lg mb-4">
            A. Personal Information Collection Statement
          </h1>
          <div className="border px-6 py-6 mb-4">
            <ol className="ml-5 list-decimal">
              <li className="mb-4 pl-4">
                Provision of personal data is necessary for processing and
                follow up on your request, enquiry, application, donation, etc.
              </li>
              <li className="mb-4 pl-4">
                The information collected from you will be used for the purposes
                described in 1 above, and/or for authenticating your eligibility
                to use library resources and services.
              </li>
              <li className="mb-4 pl-4">
                The submission of personal data is voluntary. However,
                insufficient personal data may prevent the Library from
                processing and follow up on your request, enquiry, application,
                donation, etc.
              </li>
              <li className="mb-4 pl-4">
                It is possible that any information submitted electronically
                could be observed by a third party in transit. The Library or
                the University shall not be liable for any loss or damage to you
                as a result of this.
              </li>
              <li className="mb-4 pl-4">
                Information we collect about you is strictly confidential. Data
                may be provided to the University for administrative and
                academic purposes. We will not disclose any personal information
                provided by you to any external bodies or organisations unless
                you have been consulted or we are required to do so by law.
              </li>
              <li className="mb-4 pl-4">
                Information submitted to the Library may be kept for a maximum
                period of 12 months.
              </li>
              <li className="mb-4 pl-4">
                You have the right to request access to and correction of
                information about you held by the Library. We may charge you an
                administration fee for accessing the information.
              </li>
              <li className="pl-4">
                If you wish to access or correct your personal data held by the
                Library, please submit a request to libdpo@eduhk.hk.
              </li>
            </ol>
          </div>
          <h1 className="font-bold text-lg mb-4">
            B. Terms and Conditions of Application for EdUHK Library Membership
          </h1>
          <div className="border px-6 py-6 mb-4">
            <ol className="ml-5 list-decimal">
              <li className="mb-4 pl-4">
                The applicant is required to read and observe all{" "}
                <a
                  href="https://www.lib.eduhk.hk/about/policies-regulations/regulations"
                  target="_blank"
                  rel="noreferrer"
                  className="text-orange-600 hover:text-orange-700 underline"
                >
                  rules and regulations
                </a>{" "}
                of the Library as provided on EdUHK Library Website and other
                documentation.
              </li>
              <li className="mb-4 pl-4">
                The applicant must keep his/her EdUHK Library Card for his/her
                own use.
              </li>
              <li className="mb-4 pl-4">
                The Librarian reserves the right not to approve any application.
              </li>
              <li className="pl-4">
                All requests for refund of deposit must be made within 36 months
                from membership expiration or termination, after which requests
                for refund will not be entertained.
              </li>
            </ol>
          </div>
          <div className="mb-8">
            <p className="font-bold mb-4">Declaration</p>
            <label>
              <input
                type="checkbox"
                name="agree"
                className="mr-2"
                checked={store.form.agree}
                onChange={(e) => store.updateForm("agree", e.target.checked)}
              />{" "}
              I have read and agree to the above "Personal Information
              Collection Statement" and "Terms and Conditions of Application for
              EdUHK Library Membership".
            </label>
          </div>
          <div className="flex items-center justify-center mb-8">
            <button
              className="border rounded-full px-4 py-2 w-48 text-center inline-block text-gray-600 hover:bg-gray-200 transition duration-200 focus:outline-none"
              onClick={onCancelApp}
            >
              Cancel
            </button>
            <button
              className="border border-orange-600 rounded-full px-4 py-2 w-48 text-center inline-block bg-orange-600 text-white ml-8 hover:bg-orange-700 transition duration-200 focus:outline-none"
              onClick={onNext}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
